import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            为什么数百万吃瓜群众选择吃瓜在线
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="text-center p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feat.icon} text-2xl text-primary-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3 whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}